module.exports = __webpack_public_path__ + "static/img/evpg.71b0acf.jpg";